import React from "react";
import { CheckoutItemsProps } from "../../../../store/modules/checkout/types";
import { ProductImage } from "../ProductImage";
import { ContainerImagem, Content, ProductRow } from "../styles";
import { ProductDetail } from "../ProductDetail";
import { ProductCardActions } from "../ProductCartActions";

interface IProductViewNotAllow {
    product: CheckoutItemsProps;
}

export function ProductViewNotAllow({ product }: IProductViewNotAllow) {
    return (
        <ProductRow>
            <ContainerImagem>
                <ProductImage product={product} />
            </ContainerImagem>
            <Content>
                <ProductDetail.Root>
                    <ProductDetail.Title title={product.product.short_description || ""} />
                    <ProductDetail.Alert message="Produto indisponível na loja selecionada" />
                </ProductDetail.Root>
                <ProductCardActions.Root>
                    <ProductCardActions.Delete productId={product.product.product_id} />
                </ProductCardActions.Root>
            </Content>
        </ProductRow>
    )
}